import { render, staticRenderFns } from "./TotalCheckinsCard.vue?vue&type=template&id=06f958fb&scoped=true"
import script from "./TotalCheckinsCard.vue?vue&type=script&lang=js"
export * from "./TotalCheckinsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f958fb",
  null
  
)

export default component.exports